import {IStore} from '@/store/types';
import {IModuleState} from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState: IModuleState = {
    dpsPage: {data: [], pageNum: 0, pageSize: 0, total: 0, loading: false},
    dpscPage: {data: [], pageNum: 0, pageSize: 0, total: 0, loading: false},
    confirm: {title: '', content: '', name: '', visible: false, loading: false},
    search: null,
    dpscSearch: null,
    loading: false,
};

export default {namespaced: true, state: initialState, actions, mutations} as IStore<IModuleState>;
